import { Routes } from '@angular/router';
import { Layout } from './layout/layout';
import { authGuard } from './features/auth/guards/auth.guard';
import {
    riskRuleListResolver,
    riskRuleDetailResolver,
} from './features/risk-rules/resolvers/risk-rule.resolver';
import {
    groupListResolver,
    groupDetailResolver,
} from './features/group-management/resolvers/group-management.resolver';
import { ManualApprovalDetailResolver } from './features/manual-approval/resolvers/manual-approval.resolver';
import { ROUTE_SEGMENTS } from './shared/constants/routes';

export const routes: Routes = [
    {
        path: ROUTE_SEGMENTS.auth,
        loadChildren: () =>
            import('./features/auth/auth.routes').then((r) => r.AUTH_ROUTES),
    },

    {
        path: '',
        component: Layout,
        canActivate: [authGuard],
        children: [
            {
                path: ROUTE_SEGMENTS.dashboard,
                loadComponent: () =>
                    import(
                        './features/dashboard/screens/dashboard/dashboard'
                    ).then((c) => c.Dashboard),
            },
            {
                path: ROUTE_SEGMENTS.betTicker,
                loadComponent: () =>
                    import(
                        './features/bet-ticker/screens/bet-ticker/bet-ticker'
                    ).then((c) => c.BetTicker),
            },
            {
                path: ROUTE_SEGMENTS.betHistory,
                loadComponent: () =>
                    import(
                        './features/bet-history/screens/bet-history/bet-history'
                    ).then((c) => c.BetHistory),
            },
            {
                path: `${ROUTE_SEGMENTS.riskRuleList}/:riskRuleType`,
                loadComponent: () =>
                    import(
                        './features/risk-rules/screens/risk-rule-list/risk-rule-list'
                    ).then((c) => c.RiskRuleList),
                resolve: {
                    riskRuleListResolver,
                },
            },
            {
                path: `${ROUTE_SEGMENTS.riskRuleDetails}/:riskRuleType/add`,
                loadComponent: () =>
                    import(
                        './features/risk-rules/screens/risk-rule-details/risk-rule-details'
                    ).then((c) => c.RiskRuleDetails),
                resolve: {
                    riskRuleDetailResolver,
                },
            },
            {
                path: `${ROUTE_SEGMENTS.riskRuleDetails}/:riskRuleType/edit/:id`,
                loadComponent: () =>
                    import(
                        './features/risk-rules/screens/risk-rule-details/risk-rule-details'
                    ).then((c) => c.RiskRuleDetails),
                resolve: {
                    riskRuleDetailResolver,
                },
            },
            {
                path: `${ROUTE_SEGMENTS.groupList}/:groupType`,
                loadComponent: () =>
                    import(
                        './features/group-management/screens/group-list/group-list'
                    ).then((c) => c.GroupList),
                resolve: {
                    groupListResolver,
                },
            },
            {
                path: `${ROUTE_SEGMENTS.groupDetails}/:groupType/add`,
                loadComponent: () =>
                    import(
                        './features/group-management/screens/group-details/group-details'
                    ).then((c) => c.GroupDetails),
                resolve: {
                    groupDetailResolver,
                },
            },
            {
                path: `${ROUTE_SEGMENTS.groupDetails}/:groupType/edit/:id`,
                loadComponent: () =>
                    import(
                        './features/group-management/screens/group-details/group-details'
                    ).then((c) => c.GroupDetails),
                resolve: {
                    groupDetailResolver,
                },
            },
            {
                path: ROUTE_SEGMENTS.manualApprovalList,
                loadComponent: () =>
                    import(
                        './features/manual-approval/screens/manual-approval-list/manual-approval-list'
                    ).then((c) => c.ManualApprovalList),
            },
            {
                path: `${ROUTE_SEGMENTS.manualApprovalDetails}/:id`,
                loadComponent: () =>
                    import(
                        './features/manual-approval/screens/manual-approval-details/manual-approval-details'
                    ).then((c) => c.ManualApprovalDetails),
                resolve: {
                    ManualApprovalDetailResolver,
                },
            },
            {
                path: ROUTE_SEGMENTS.liabilityViewer,
                loadComponent: () =>
                    import(
                        './features/liability-viewer/screens/liability-viewer/liability-viewer'
                    ).then((c) => c.LiabilityViewer),
            },
            {
                path: ROUTE_SEGMENTS.betslipPusher,
                loadComponent: () =>
                    import(
                        './features/betslip-pusher/screens/betslip-pusher/betslip-pusher'
                    ).then((c) => c.BetslipPusher),
            },
            {
                path: '',
                redirectTo: ROUTE_SEGMENTS.dashboard,
                pathMatch: 'full',
            },
            // AB#9027: without a catch-all, any mistyped/stale URL under the
            // authenticated shell (typo, removed feature, stale bookmark)
            // renders the Layout with an empty router-outlet and no content.
            // Route it back to the dashboard instead of dead-ending silently.
            {
                path: '**',
                redirectTo: ROUTE_SEGMENTS.dashboard,
            },
        ],
    },
    // Safety net for anything outside the authenticated shell entirely (e.g.
    // a stray top-level segment) — falls through to the Layout root, which
    // itself redirects to the dashboard via the child route above.
    {
        path: '**',
        redirectTo: '',
    },
];
